import styled from 'styled-components';

import {
  black,
  blue,
  darkGray,
  green,
  lightGray,
  mediumGray,
  purple,
  red,
  white,
} from '../../modules/colors';
import { fonts, spacing } from '../../modules/metrics';

const options = {
  color: {
    primary: white,
    secondary: black,
    inverted: white,
    danger: white,
    duplicate: white,
    save: white,
    edit: white,
    cancel: white,
    request: darkGray,
  },
  background: {
    primary: black,
    secondary: white,
    inverted: 'transparent',
    danger: red,
    duplicate: purple,
    save: green,
    edit: blue,
    cancel: mediumGray,
    request: white,
  },
  border: {
    primary: 'none',
    secondary: `1px ${black} solid`,
    inverted: `1px ${white} solid`,
    danger: 'none',
    duplicate: 'none',
    save: 'none',
    edit: 'none',
    cancel: 'none',
    request: 'none',
  },
  size: {
    xs: {
      font: fonts.xs,
      spacing: spacing.sm,
    },
    sm: {
      font: fonts.xs,
      spacing: spacing.sm,
    },
    md: {
      font: fonts.sm,
      spacing: spacing.md,
    },
    lg: {
      font: fonts.md,
      spacing: spacing.md,
    },
  },
};

export const Wrapper = styled.button`
  display: flex;
  align-items: center;
  color: ${(props) => options.color[props['data-kind']]};
  background-color: ${(props) => options.background[props['data-kind']]};
  border-radius: ${spacing.sm}px;
  border: ${(props) => options.border[props['data-kind']]};
  font-size: ${(props) => options.size[props.size].font}px;
  font-weight: 500;
  padding: ${(props) =>
    props.icon
      ? `${options.size[props.size].spacing}px`
      : `${spacing.md}px ${spacing.lg}px`};
  text-align: center;
  cursor: pointer;
  transition: opacity 0.5s ease 0s;

  :hover {
    opacity: 0.5;
  }

  :disabled {
    opacity: 1;
    background-color: ${lightGray};
    color: ${white};
    cursor: not-allowed;
  }

  > img {
    ${(props) => (props.text ? `margin: 0 ${spacing.sm}px;` : 0)}
  }
`;

export const TextWrapper = styled.span`
  white-space: nowrap;
  ${(props) => props.icon && `margin: 0 ${spacing.sm}px;`}
`;
